import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private baseUrl: string = environment.apiUrl;

  constructor(private http: HttpClient) { }

  private static handleError(error: HttpErrorResponse) {
    console.log(error);

    // return an observable with a user friendly message
    return throwError('Error! something went wrong.');
  }

  public changePassword(Payload: any) {

    // var reqHeaders = new HttpHeaders({'Content-Type':undefined});
    return this.http.post<any>(`${this.baseUrl}/user/changepassword`, Payload)
      .pipe(map(user => {
        return user;
      }));

  }


  public addUser(userPayload) {

    // var reqHeaders = new HttpHeaders({'Content-Type':undefined});
    return this.http.post<any>(`${this.baseUrl}/user/signup`, userPayload)
      .pipe(map(user => {
        return user;
      }));

  }

  public changeStatus(Payload: any) {

    // var reqHeaders = new HttpHeaders({'Content-Type':undefined});
    return this.http.post<any>(`${this.baseUrl}/user/changestatus`, Payload)
      .pipe(map(user => {
        return user;
      }));

  }

  public blockUnblockUser(Payload: any) {

    // var reqHeaders = new HttpHeaders({'Content-Type':undefined});
    return this.http.post<any>(`${this.baseUrl}/user/blockUnblockUser`, Payload)
      .pipe(map(user => {
        return user;
      }));

  }

  public changeMciStatus(Payload: any) {
    return this.http.post<any>(`${this.baseUrl}/user/changemcistatus`, Payload)
      .pipe(map(user => {
        return user;
      }));
  }

  public updateProfile(data) {
    // var reqHeaders = new HttpHeaders({'Content-Type':undefined});
    return this.http.post<any>(`${this.baseUrl}/user/updateuser`, data)
      .pipe(map(user => {
        return user;
      }));

  }

  public updateUserPassword(data) {
    // var reqHeaders = new HttpHeaders({'Content-Type':undefined});
    return this.http.post<any>(`${this.baseUrl}/user/changeUserPassword`, data)
      .pipe(map(user => {
        return user;
      }));

  }

  public getUserTestList(userid){
    return this.http.get(`${this.baseUrl}/test/get-user-test-result/${userid}`).pipe(
      map((res: any) => {
        return res;
      }));
      //catchError(UserService.handleError));
  }

  public getSingleTestResult(id){
    return this.http.get(`${this.baseUrl}/test/get-test-result/${id}`).pipe(
      map((res: any) => {
        return res;
      }));
    //catchError(UserService.handleError));
  }

  public getTestSingleQuestionById(id){
    return this.http.get(`${this.baseUrl}/test/get-test-single-question/${id}`).pipe(
      map((res: any) => {
        return res;
      }));
    //catchError(UserService.handleError));
  }

  public resetPassword(data) {
    // var reqHeaders = new HttpHeaders({'Content-Type':undefined});
    return this.http.post<any>(`${this.baseUrl}/user/reset-password`, data)
      .pipe(map(res => {
        return res;
      }));

  }
  public storeResetPassword(data) {
    // var reqHeaders = new HttpHeaders({'Content-Type':undefined});
    return this.http.post<any>(`${this.baseUrl}/user/store-reset-password`, data)
      .pipe(map(res => {
        return res;
      }));

  }
}
